/* =========================================================================
   SAMSARA — COFFEE-VARIANT-POPUP.JS
   Variant selector modal pentru coffee-card "Adaugă" pe multi-variant products.
   Pattern: option groups (Gramaj + Măcinare) cu pills per option value.
   Combinația selectată → matching variant.id pentru hidden input.
   Submit → /cart/add → cart-drawer.js intercept handles add + open drawer.
   ========================================================================= */

(function () {
  'use strict';

  const dialog = document.querySelector('[data-coffee-variant-popup]');
  if (!dialog) return;

  const form = dialog.querySelector('[data-coffee-variant-popup-form]');
  const variantIdInput = dialog.querySelector('[data-coffee-variant-popup-variant-id]');
  const titleEl = dialog.querySelector('[data-coffee-variant-popup-title]');
  const originEl = dialog.querySelector('[data-coffee-variant-popup-origin]');
  const processEl = dialog.querySelector('[data-coffee-variant-popup-process]');
  const metaSepEl = dialog.querySelector('[data-coffee-variant-popup-meta-sep]');
  const imageEl = dialog.querySelector('[data-coffee-variant-popup-image]');
  const priceEl = dialog.querySelector('[data-coffee-variant-popup-price]');
  const optionsContainer = dialog.querySelector('[data-coffee-variant-popup-options]');
  const submitBtn = dialog.querySelector('[data-coffee-variant-popup-submit]');
  const closeBtn = dialog.querySelector('[data-coffee-variant-popup-close]');
  const qtyInput = dialog.querySelector('[data-coffee-variant-popup-qty-input]');
  const qtyDecBtn = dialog.querySelector('[data-coffee-variant-popup-qty-decrease]');
  const qtyIncBtn = dialog.querySelector('[data-coffee-variant-popup-qty-increase]');

  let currentOptions = [];
  let currentVariants = [];

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('[data-coffee-variant-trigger]');
    if (!trigger) return;
    e.preventDefault();
    openPopup(trigger);
  });

  closeBtn.addEventListener('click', closePopup);

  /* Curatarea scroll lock-ului sta pe evenimentul NATIV `close`, care se
     declanseaza pe ORICE cale de inchidere: butonul X, click pe backdrop, tasta
     ESC si `dialog.close()` apelat din cart-drawer.js dupa un add reusit.
     Inainte era legata doar de closePopup(), deci calea din cart-drawer lasa
     `is-scroll-locked` pe body si pagina ramanea blocata (raportat 2026-08-24). */
  dialog.addEventListener('close', releaseScrollLock);

  dialog.addEventListener('click', function (e) {
    if (e.target === dialog) closePopup();
  });

  optionsContainer.addEventListener('change', function (e) {
    const radio = e.target.closest('[data-coffee-variant-option-input]');
    if (!radio) return;
    syncVariant();
  });

  function openPopup(trigger) {
    let options, variants;
    try {
      options = JSON.parse(trigger.dataset.options || '[]');
      variants = JSON.parse(trigger.dataset.variants || '[]');
    } catch (err) {
      console.warn('[coffee-variant-popup] invalid JSON', err);
      return;
    }
    if (!variants.length || !options.length) return;

    currentOptions = options;
    currentVariants = variants;

    titleEl.textContent = trigger.dataset.productTitle || '';

    const origin = trigger.dataset.productOrigin || '';
    const process = trigger.dataset.productProcess || '';
    originEl.textContent = origin;
    processEl.textContent = process;
    metaSepEl.hidden = !(origin && process);
    originEl.hidden = !origin;
    processEl.hidden = !process;

    if (trigger.dataset.productImage) {
      imageEl.src = trigger.dataset.productImage;
      imageEl.alt = trigger.dataset.productTitle || '';
      imageEl.hidden = false;
    } else {
      imageEl.hidden = true;
      imageEl.removeAttribute('src');
    }

    // Build option groups (Gramaj, Măcinare) with pills per value
    const firstAvailable = variants.find(function (v) { return v.available; }) || variants[0];
    const defaultOptionValues = firstAvailable.options;

    optionsContainer.innerHTML = options.map(function (opt, optIdx) {
      const optNameLc = (opt.name || '').toLowerCase();
      const isGrind = optNameLc.indexOf('măcinare') !== -1 ||
                      optNameLc.indexOf('macinare') !== -1 ||
                      optNameLc.indexOf('grind') !== -1;

      if (isGrind) {
        const optionsHtml = opt.values.map(function (value) {
          const isDefault = defaultOptionValues[optIdx] === value;
          return '<option value="' + escapeAttr(value) + '"' + (isDefault ? ' selected' : '') + '>' + escapeHtml(value) + '</option>';
        }).join('');
        return '' +
          '<fieldset class="coffee-variant-popup__option-group coffee-variant-popup__option-group--select">' +
            '<legend class="coffee-variant-popup__option-name">' + escapeHtml(opt.name) + '</legend>' +
            '<div class="coffee-variant-popup__select-wrap">' +
              '<select class="coffee-variant-popup__option-select" aria-label="' + escapeAttr(opt.name) + '" data-coffee-variant-option-input data-option-position="' + opt.position + '">' +
                optionsHtml +
              '</select>' +
              '<span class="coffee-variant-popup__select-arrow" aria-hidden="true">&#9662;</span>' +
            '</div>' +
          '</fieldset>';
      }

      const pills = opt.values.map(function (value) {
        const isDefault = defaultOptionValues[optIdx] === value;
        const id = 'cvp-opt-' + opt.position + '-' + slugify(value);
        return '' +
          '<input type="radio" id="' + id + '" name="cvp-option-' + opt.position + '" value="' + escapeAttr(value) + '" ' + (isDefault ? 'checked' : '') + ' class="coffee-variant-popup__option-input" data-coffee-variant-option-input data-option-position="' + opt.position + '">' +
          '<label for="' + id + '" class="coffee-variant-popup__option-pill">' + escapeHtml(value) + '</label>';
      }).join('');

      return '' +
        '<fieldset class="coffee-variant-popup__option-group">' +
          '<legend class="coffee-variant-popup__option-name">' + escapeHtml(opt.name) + '</legend>' +
          '<div class="coffee-variant-popup__option-values" role="radiogroup" aria-label="' + escapeAttr(opt.name) + '">' + pills + '</div>' +
        '</fieldset>';
    }).join('');

    syncVariant();
    setQty(QTY_MIN); // fiecare produs porneste de la 1

    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
      dialog.style.display = 'block';
    }
    document.body.classList.add('is-scroll-locked');
  }

  /* ----- Cantitate ----- */
  /* Pana la 2026-08-24 quantity era un hidden fix pe 1, deci de pe home nu se
     putea adauga decat o punga. Stepper-ul scrie in acelasi input `quantity`,
     citit ca atare de cart-drawer.js prin FormData. */

  const QTY_MIN = 1;
  const QTY_MAX = 99;

  function clampQty(value) {
    const n = parseInt(value, 10);
    if (isNaN(n)) return QTY_MIN;
    return Math.min(QTY_MAX, Math.max(QTY_MIN, n));
  }

  function setQty(value) {
    if (!qtyInput) return;
    const n = clampQty(value);
    qtyInput.value = String(n);
    if (qtyDecBtn) qtyDecBtn.disabled = n <= QTY_MIN;
    if (qtyIncBtn) qtyIncBtn.disabled = n >= QTY_MAX;
  }

  if (qtyDecBtn) {
    qtyDecBtn.addEventListener('click', function () {
      setQty(parseInt(qtyInput.value, 10) - 1);
    });
  }
  if (qtyIncBtn) {
    qtyIncBtn.addEventListener('click', function () {
      setQty(parseInt(qtyInput.value, 10) + 1);
    });
  }
  if (qtyInput) {
    // `change`, nu `input` — altfel stergerea campului sare instant la 1 in timp ce scrii
    qtyInput.addEventListener('change', function () {
      setQty(qtyInput.value);
    });
  }

  function releaseScrollLock() {
    document.body.classList.remove('is-scroll-locked');
  }

  function closePopup() {
    if (typeof dialog.close === 'function') {
      dialog.close(); // evenimentul `close` face curatarea
    } else {
      // fallback fara <dialog> nativ: nu exista eveniment `close`, curatam manual
      dialog.removeAttribute('open');
      dialog.style.display = 'none';
      releaseScrollLock();
    }
  }

  function getSelectedOptionValues() {
    const result = new Array(currentOptions.length);
    currentOptions.forEach(function (opt, idx) {
      // Handle both <select> (dropdown for Măcinare) and <input type="radio">
      const selectEl = optionsContainer.querySelector('select[data-option-position="' + opt.position + '"]');
      if (selectEl) {
        result[idx] = selectEl.value;
        return;
      }
      const checked = optionsContainer.querySelector('[data-option-position="' + opt.position + '"]:checked');
      if (checked) result[idx] = checked.value;
    });
    return result;
  }

  function syncVariant() {
    const selected = getSelectedOptionValues();
    const match = currentVariants.find(function (v) {
      return v.options.every(function (o, i) { return o === selected[i]; });
    });

    if (!match) {
      variantIdInput.value = '';
      priceEl.textContent = '—';
      submitBtn.disabled = true;
      submitBtn.textContent = 'Indisponibil';
      return;
    }

    variantIdInput.value = match.id;
    priceEl.textContent = match.price;

    if (!match.available) {
      submitBtn.disabled = true;
      submitBtn.textContent = 'Stoc epuizat';
    } else {
      submitBtn.disabled = false;
      submitBtn.textContent = 'Adaugă în coș';
    }
  }

  // NU închidem popup-ul la submit. cart-drawer.js îl închide DOAR pe success
  // (după ce drawer-ul s-a deschis). Pe eroare (422 sold-out / rețea) rămâne
  // deschis ca .is-add-error + .btn-feedback din interior să fie vizibile.

  function slugify(s) {
    return String(s).toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }

  function escapeHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeAttr(s) {
    return escapeHtml(s);
  }
})();
